import React, { useEffect, useReducer } from "react";
import { callAPI, useAPI } from "../lib/common";
import useTemplateInstance from "../Webshop/Mobile/hooks/useTemplateInstance";

export const PackageInstanceContext = React.createContext();

export const ALLOW_SUBJECT_CHANGE_YES = 0;
export const ALLOW_SUBJECT_CHANGE_NO = 1;
export const ALLOW_SUBJECT_CHANGE_IF_SAME_JOB = 2;
export const ALLOW_SUBJECT_CHANGE_IF_SAME_JOB_TYPE = 3;
export const ALLOW_SUBJECT_CHANGE_REPLACE_PICTURES = 4;

export const ACTION_SET_PACKAGE_INSTANCE = "setPackageInstance";
export const ACTION_START_LOADING = "startLoading";
export const ACTION_STOP_LOADING = "stopLoading";
export const ACTION_SET_CURRENT_PACKAGE_ITEM_INDEX = "setCurrentProductNum";
export const ACTIONS_REPLACE_PACKAGE_ITEM = "replacePackageItem";
export const ACTIONS_SET_ADDING_TO_CART = "setAddingToCart";
export const ACTIONS_SET_FAILED_ADDING_TO_CART = "setFailedAddingToCart";
export const ACTIONS_SET_ADDED_TO_CART = "setAddedToCart";

export const editPackageForceSetSameSubject = (allowSubjectChange) => {
  if (
    allowSubjectChange == ALLOW_SUBJECT_CHANGE_NO ||
    allowSubjectChange == ALLOW_SUBJECT_CHANGE_IF_SAME_JOB ||
    allowSubjectChange == ALLOW_SUBJECT_CHANGE_IF_SAME_JOB_TYPE ||
    allowSubjectChange == ALLOW_SUBJECT_CHANGE_REPLACE_PICTURES
  ) {
    return true;
  }
  return false;
};

const packageInstanceReducer = (state, action) => {
  console.log("Got package action", action);
  switch (action.type) {
    case ACTION_SET_PACKAGE_INSTANCE:
      return {
        ...state,
        ...action.packageInstance,
        loading: false,
      };
    case ACTIONS_REPLACE_PACKAGE_ITEM:
      return {
        ...state,
        dirty: true,
        packageItems: state.packageItems.map((packageItem) => {
          if (packageItem.uuid === action.payload.packageItem.uuid) {
            console.log(
              "Replacing package item with",
              action.payload.packageItem
            );
            return action.payload.packageItem;
          }
          return packageItem;
        }),
      };
    case ACTION_START_LOADING:
      return {
        ...state,
        loading: true,
      };
    case ACTION_STOP_LOADING:
      return {
        ...state,
        loading: false,
      };
    case ACTION_SET_CURRENT_PACKAGE_ITEM_INDEX:
      return {
        ...state,
        currentProductIndex: action.productIndex,
      };
    case ACTIONS_SET_ADDING_TO_CART:
      return {
        ...state,
        isAddingToCart: action.payload.isAddingToCart,
      };
    case ACTIONS_SET_FAILED_ADDING_TO_CART:
      return {
        ...state,
        isAddingToCart: false,
      };
    case ACTIONS_SET_ADDED_TO_CART:
      return {
        ...state,
        dirty: false,
      };
    default:
      console.log("Unknown action", action);
      return state;
  }
};

const initialState = {
  loading: true,
  currentPackageItemIndex: 0,
  dirty: false,
};

const PackageInstanceProvider = ({ children }) => {
  const [state, dispatch] = useReducer(packageInstanceReducer, initialState);

  const initializeInstanceByUuid = (packageUuid) => {
    dispatch({
      type: ACTION_START_LOADING,
    });
    callAPI(`/api/webshop/packages/${packageUuid}`, "POST")
      .then((packageInstance) => {
        initializeInstance(packageInstance);
      })
      .finally(() => {
        dispatch({
          type: ACTION_STOP_LOADING,
        });
      });
  };

  const initializeInstance = (packageInstance) => {
    dispatch({
      type: ACTION_SET_PACKAGE_INSTANCE,
      packageInstance,
    });
    setCurrentPackageItemIndex(0);
  };

  const setCurrentPackageItemIndex = (index) => {
    dispatch({
      type: ACTION_SET_CURRENT_PACKAGE_ITEM_INDEX,
      packageItemIndex: index,
    });
  };

  const updatePackageItem = (packageItem) => {
    dispatch({
      type: ACTIONS_REPLACE_PACKAGE_ITEM,
      payload: {
        packageItem,
      },
    });
  };

  console.log("Full state", state);

  return (
    <PackageInstanceContext.Provider
      value={{
        dispatch,
        state,
        loading: state.loading,
        packageItems: state.packageItems,
        currentProductIndex: state.currentProductIndex,
        isAddingToCart: state.isAddingToCart,
        allowSubjectChange: state.allowSubjectChange,
        dirty: state.dirty,
        initializeInstanceByUuid,
        initializeInstance,
        setCurrentPackageItemIndex,
        updatePackageItem,
        ...state,
      }}
    >
      {children}
    </PackageInstanceContext.Provider>
  );
};

export const usePackageInstance = () => {
  return React.useContext(PackageInstanceContext);
};

export default PackageInstanceProvider;
